import React, { useEffect, useState, useCallback, useRef } from 'react'
import useApp from 'hooks/useApp'
import { Button, LayerBottom, Toast } from 'components'
import styles from './index.module.css'
import Lib from 'library'

const EditLayer = () => {

	const App = useApp()
	const [showLayer, setShowLayer] = useState(false)
	const [myMenu, setMyMenu] = useState()
	const [myAllMenu, setMyAllMenu] = useState()
	const mounted = useRef(false);
	const [showToast, setShowToast] = useState(false);

	const [realTimeChange, setRealTimeChange] = useState(false);

	const openLayer = () => {
		// setShowLayer(true)
		App.alert({
			msg: "편집한 내용을 저장하지 않고 나갈까요?",
			ok: "나가기",
			cancel: "취소",
			confirm: true,
			type: "bottom"
		})
	}

	const closeLayer = () => {
		setShowLayer(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: <i className="icon icon_close" onClick={openLayer} />
		})
		
		App.setMainClass("white")
		App.setShowNav(false)
	}, [])


	const setCommData = useCallback((data, set)=>{
		set(prev =>  data.filter(function(item){
			let state = true
			for(var i=0; i < prev.length; i++) {
				if (item.bkmCd === prev[i].bkmCd){
					state = false;
				}
			}
			return state;
		}))
	}, [])

	const getMyallMenu = useCallback(async ()=>{
		await Lib.post(`/api/bkm/lst/mb`, data => setMyAllMenu(data));
		await Lib.post(`/api/bkm/lst/all`, data => setCommData( data, setMyAllMenu));
	}, [])

	useEffect(() => {
		Lib.post(`/api/bkm/lst/mb`, {
		}, data => {
			setMyMenu(data);
		})
	}, [realTimeChange])

	useEffect(()=>{
		mounted.current = true;
		if (mounted.current) {
			getMyallMenu();
		} 
		return () => mounted.current = false;
	}, []);

	const onMenuDelete = (item) => {
		if (myMenu.length < 5){
			setShowToast(true)
			return false
		}
		setMyMenu(prev=> prev.filter((el)=> {
			return el.bkmCd !== item.bkmCd
		}))
		setMyAllMenu(prev => [...prev,item])
	}

	const onMenuAdd = (item) => {
		if (myMenu.length > 7){
			setShowToast(true)
			return false
		}
		setMyMenu(prev => [...prev,item])
		setMyAllMenu(prev=> prev.filter((el)=> {
			return el.bkmCd !== item.bkmCd
		}))
	}

	// 설정 초기화
	const resetMenu = () => {
		Lib.post(`/api/bkm/save`,{lstMbBkm : [
				{
					bkmCd: 'MDATA01',
					sortNo: '1'
				},
				{
					bkmCd: 'MDATA02',
					sortNo: '2'
				},
				{
					bkmCd: 'MDATA03',
					sortNo: '3'
				},
				{
					bkmCd: 'MDATA04',
					sortNo: '4'
				}
			]
		}, data => {
			getMyallMenu();
			setRealTimeChange(!realTimeChange)
		})
	}

	const onAddMenu = () => {
		// if (myMenu.length < 4 || myMenu.length >8){
		// 	setShowToast(true)
		// 	return false
		// }

		const choiceMenu = []
		myMenu.forEach((el,index) => {
			console.log(index);
			choiceMenu.push({
				bkmCd : el.bkmCd,
				sortNo : String(index)
			})
		});
		Lib.post(`/api/bkm/save`,{ lstMbBkm : choiceMenu}, data => {
			alert('a')
			console.log(data)
		})
	}

	return (
		<div className="page">
			<Toast show={showToast} hide={setShowToast} text="메뉴는 최소4개-최대8개까지 설정 가능합니다." />
			<div className="flex_1">
				<div className="shadow">
					<div className="padding pt_20 pb_40">
						<div className={styles["edit-tit"]}>
							<p>MY메뉴 순서를<br />변경해보세요!</p>
							<span onClick={()=> resetMenu()}><i className="icon icon_refresh mr_5" />설정 초기화</span>
						</div>
						<span className={`${styles.guide} mt_20`}>* 최소 4개 이상 최대 8개까지 설정이 가능해요!</span>
						<ul className={`${styles["edit-group"]} mt_15`}>
							{myMenu && myMenu.map((item, index) => {
                                if (item.indstCd === 'CAPITAL' || item.indstCd === 'GINSU' || item.indstCd === 'BOND' || item.indstCd === 'P2P') {
                                        /* 20221024 개발일정에 따른 업무범위 축소로 해당 메뉴 제외 */
                                        return null
                                    }
                                    else {
                                        return (
                                            <li key={index}>{item.bkmNm} <span className="icon icon_edit_close" onClick={() => onMenuDelete(item)} /></li>
                                        )
                                    }
//									return (
//										<li key={index}>{item.bkmNm} <span className="icon icon_edit_close" onClick={() => onMenuDelete(item)} /></li>
//									)
                                })
                            }
						</ul>
					</div>
				</div>
				<div className="padding">
					<div className={`${styles["edit-tit"]} mt_10`}>
						<p>자주 이용하는<br />메뉴를 더 골라보세요.</p>
					</div>

					<h3 className={`${styles.sTitle} mt_40`}>마이데이터</h3>
					<ul className={`${styles["edit-group"]} ${styles.gray} mt_10`}>
						{myAllMenu && myAllMenu.map((item,index) => {
							if (item.ctgryCd === 'BKM_LIFE'){
								return null
							}
							else if (item.indstCd === 'CAPITAL' || item.indstCd === 'GINSU' || item.indstCd === 'BOND' || item.indstCd === 'P2P') {
                                /* 20221024 개발일정에 따른 업무범위 축소로 해당 메뉴 제외 */
                                return null
                            }
							else {
								return (
									<li key={index} onClick={()=> onMenuAdd(item)}>{item.bkmNm}</li>
								)
							}
						})}
					</ul>
					<h3 className={`${styles.sTitle} mt_40`}>라이프</h3>
					<ul className={`${styles["edit-group"]} ${styles.gray} mt_10`}>
					{myAllMenu && myAllMenu.map((item,index) => {
							if (item.ctgryCd === 'BKM_MDATA'){
								return null
							} else {
								return (
									<li key={index} onClick={()=> onMenuAdd(item)}>{item.bkmNm}</li>
								)
							}
						})}
					</ul>
				</div>
			</div>
			<div className="padding flex-shrink_0" onClick={onAddMenu}>
				<Button className="btn btn--big">적용하기</Button>
			</div>
			<ConfirmLayer show={showLayer} closeLayer={closeLayer} />
		</div>
	)
}

const ConfirmLayer = ({ show, closeLayer }) => {
	return (
		<LayerBottom show={show} closeButton={false} closeConfirm={closeLayer} outside={
			<div className="btn-group">
				<Button className="btn btn--big btn-layer btn--gray" onClick={() => closeLayer()}>나가기</Button>
				<Button className="btn btn--big btn-layer" onClick={() => closeLayer()}>취소</Button>
			</div>
		}>
			<div className="layer-text py_10">
				편집한 내용을 저장하지 않고 나갈까요?
			</div>
		</LayerBottom>
	)
}

export default EditLayer
